import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';

const GetProjectProfitBreakdown = graphql(`
  query GetProjectProfitBreakdown($projectId: ID!) {
    projectById(id: $projectId) {
      profitBreakdown {
        revenue {
          actual {
            currency {
              code
              exponent
            }
            value
          }
          forecast {
            currency {
              code
              exponent
            }
            value
          }
          committed {
            value
          }
        }
        labour {
          actual {
            currency {
              code
              exponent
            }
            value
          }
          forecast {
            currency {
              code
              exponent
            }
            value
          }
          committed {
            value
          }
        }
        materials {
          actual {
            currency {
              code
              exponent
            }
            value
          }
          forecast {
            currency {
              code
              exponent
            }
            value
          }
          committed {
            value
          }
        }
        profit {
          actual {
            currency {
              code
              exponent
            }
            value
          }
          forecast {
            currency {
              code
              exponent
            }
            value
          }
        }
      }
    }
  }
  fragment BreakdownItem on ForecastValue {
    actual {
      currency {
        code
        exponent
      }
      value
    }
    forecast {
      currency {
        code
        exponent
      }
      value
    }
  }
`);

const useGetProjectProfitBreakdown = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.profitBreakdown(projectId!),
    queryFn: () => {
      return gqlClient.request(GetProjectProfitBreakdown, {
        projectId: projectId!,
      });
    },
  });

  return { data, profitBreakdown: data?.projectById?.profitBreakdown, ...rest };
};

export default useGetProjectProfitBreakdown;
